import { nanoid } from 'nanoid'
import type { IAddContactNoteCallingActionPayload } from 'entities/AICalling/api/types.ts'
import { type IAddContactNoteActionProps } from 'widgets/TemplateActions/addContactNote/addContactNote.tsx'

export const createAddContactNoteCallingAction = (
  data: IAddContactNoteActionProps['data'],
  token_id?: string
): IAddContactNoteCallingActionPayload => {
  return {
    action_type: 'add_contact_note',
    trigger_type: 'end_of_call',
    settings: {
      token_id: token_id ?? nanoid(),
      auto: data?.auto || false,
      message: data?.message ?? '',
      media_url: data?.media_url || [],
    },
  }
}
